import { createAction, props } from '@ngrx/store';
import { TenantIndependentFeed } from './types';

const feature = '[Tenant independent content group list]';

export const loadScreen = createAction(`${feature} Load screen`);
export const loadScreenSuccess = createAction(`${feature} Load screen success`, props<{ feeds: TenantIndependentFeed[] }>());
export const loadScreenFail = createAction(`${feature} Load screen fail`, props<{ errorMessage: string }>());
